import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantAnnualIncomeService } from '../../services/wealthlane-customer-services';
import { ParticipantCashTransferServiceService } from '../../services/wealthlane-award-settlement-services';

const useGetParticipantBankTransferType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const participantBankTransferType = useQuery(
    ['getParticipantBankTransferType'],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceService.getApiAwardSettlementApiAppParticipantCashTransferServiceTransferTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: String(item.id) ?? '',
          };
        });
      },
    }
  );

  return participantBankTransferType;
};

export default useGetParticipantBankTransferType;
